export default __webpack_public_path__ + "static/media/BrainlabNowW05-Regular.13c41f7b.woff";